import React, { PropTypes } from 'react';
import Slider from 'react-slick';

import Screen, { MaxResolutions } from '../../Shared/Helpers/Screen';
import BusyIndicator from '../../Shared/Helpers/BusyIndicator/BusyIndicator';
import './LandingCarousel.scss';

export default class LandingCarousel extends React.Component {
    render() {
        let settings = {
            slidesToShow: this.props.columnsAmount,
            slidesToScroll: this.props.columnsAmount,
            infinite: false,
            nextArrow: <NextArrow />,
            prevArrow: <PrevArrow />,
            responsive: [
                {
                    breakpoint: 100000,
                    settings: this.props.isSlick ? '' : 'unslick'
                }
            ]
        }

        let view = null;

        if (!this.props.children || !this.props.children.length) {
            view = <BusyIndicator />
        } else {
            view = (
                <Slider {...settings}>
                    {this.props.children}
                </Slider>);
        }

        return (
            <div className="carousel">
                {view}
            </div>
        );
    }
}

LandingCarousel.propTypes = {
    columnsAmount: PropTypes.number.isRequired
};

let PrevArrow = (props) => {
    return (<img className={props.className}
        src="/images/shared/Carousel/prev-arrow.svg"
        alt="prev-arrow"
        onClick={props.onClick} />);
};

let NextArrow = (props) => {
    return (
        <img className={props.className}
            src="/images/shared/Carousel/next-arrow.svg"
            alt="next-arrow"
            onClick={props.onClick} />);
};


// WEBPACK FOOTER //
// ./Src/LandingPage/LandingCarousel/LandingCarousel.jsx